import { Component } from '@angular/core';
import { CheckIcon, ExclamationTriangleIcon, InfoCircleIcon, TimesCircleIcon } from '@openng/optimus-ui/icons';
import { Toast } from '@openng/optimus-ui/toast';

import { ToastProgressSyncDirective } from './toast-progress-sync.directive';

@Component({
	selector: 'app-notifications',
	template: `
		<p-toast>
			<ng-template #message let-message>
				@switch (message.severity) {
					@case ('success') {
						<svg data-p-icon="check" class="p-toast-message-icon" aria-hidden="true"></svg>
					}
					@case ('error') {
						<svg data-p-icon="times-circle" class="p-toast-message-icon" aria-hidden="true"></svg>
					}
					@case ('warn') {
						<svg data-p-icon="exclamation-triangle" class="p-toast-message-icon" aria-hidden="true"></svg>
					}
					@default {
						<svg data-p-icon="info-circle" class="p-toast-message-icon" aria-hidden="true"></svg>
					}
				}
				<div class="p-toast-message-text">
					<div class="p-toast-summary">{{ message.summary }}</div>
					<div class="p-toast-detail">{{ message.detail }}</div>
				</div>
				@if (message.life && !message.sticky) {
					<div
						appToastProgressSync
						class="toast-progress toast-progress--{{ message.severity }}"
						[style.animation-duration.ms]="message.life"
					></div>
				}
			</ng-template>
		</p-toast>
	`,
	imports: [Toast, CheckIcon, ExclamationTriangleIcon, InfoCircleIcon, TimesCircleIcon, ToastProgressSyncDirective],
})
export class NotificationsComponent {}
